import { render } from "./Verifier.vue?vue&type=template&id=73fbe0a3&scoped=true"
import script from "./Verifier.vue?vue&type=script&lang=js"
export * from "./Verifier.vue?vue&type=script&lang=js"

import "./Verifier.vue?vue&type=style&index=0&id=73fbe0a3&scoped=true&lang=css"

import exportComponent from "/builds/prv-dkomm/projects/edtools/zyklus3/ba-2021-trieu/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73fbe0a3"]])

export default __exports__